export enum CUSTOM_APP {
  LMW4 = "LMW4",
  LMW = "lmw",
  OCN = "OCN"
}
